import sidebarButtonStyles from "@/components/common/sidebar-buttons/styles/sidebar-buttons.module.scss";
import { useReferFriend } from "@/components/pages/pricing-b/hooks/use-refer-friend";
import UnfilledButton from "@/components/common/unfilled-button";

const InviteFriendsMainButton = () => {
  const { showInviteFriendModal } = useReferFriend();

  return (
    <div className={sidebarButtonStyles.button_wrapper}>
      <UnfilledButton
        text={"Invite friends"}
        textColor={"#F9A825"}
        borderColor={"#F9A825"}
        onClick={showInviteFriendModal}
      />
    </div>
  );
};

export default InviteFriendsMainButton;
